import {ACTION_SIDEBAR_TAB} from "@/valueholders/enums";


/**
 * Import Dependency
 */

/**
 * Import API
 */

/**
 * Declare Variable
 */
const DEFAULT_TAB = ACTION_SIDEBAR_TAB.OPMERKINGEN

const state = {
  selectedActionSidebarTab: DEFAULT_TAB
}

const getters = {
  getSelectedActionSidebarTab: state => state.selectedActionSidebarTab
}

const actions = {
  selectTab({commit}, {tabName}) {
    commit('setSelectedActionSidebarTab', {tabName})
  },
}

const mutations = {
  setSelectedActionSidebarTab(state, { tabName }) {
    state.selectedActionSidebarTab = tabName ? tabName : DEFAULT_TAB
  },
}

/**
 * Export
 */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
